import { CgOptions, CgWebsite } from "react-icons/cg";
import { FaBell, FaSync } from "react-icons/fa";
import { MdCancel, MdSettings } from "react-icons/md";
import { SlOptionsVertical } from "react-icons/sl";


export function FirefoxInstructions({ isMobile }: { isMobile: boolean }) {
  const instructions =
    isMobile
      ? [
        { icon: <SlOptionsVertical />, text: "הקש על שלוש הנקודות בפינה השמאלית העליונה" },
        { icon: <MdSettings />, text: 'בחר ב"הגדרות"' },
        { icon: <CgWebsite />, text: 'גלול מטה ובחר ב"הגדרות אתר"' },
        { icon: <FaBell />, text: 'הקש על "התראות"' },
        { icon: <FaSync />, text: "לחץ על אפשר או 'לבקש לאפשר'" },
      ]
      : [
        {
          icon: <CgOptions />, text: <>לחץ על סמל ההגדרות
            <CgOptions className="bg-gray-200 aspect-square rounded-full p-1 text-black inline mx-1" fill="black" size={ "1.5em" } />
            ליד כתובת האתר בשורת הכתובת</>
        },
        { icon: <FaBell />, text: 'מצא את הרשאת "שליחת התראות"' },
        { icon: <MdCancel />, text: 'לחץ על האיקס ליד להסרת החסימה' },
      ]

  return (
    <ol className="space-y-4">
      { instructions.map((instruction, index) => (
        <li key={ index } className="flex items-center space-x-4 rtl:space-x-reverse">
          <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-purple-600 rounded-full text-white">
            { instruction.icon }
          </span>
          <span className="text-gray-200">{ instruction.text }.</span>
        </li>
      )) }
    </ol>
  )
}

